import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
} from "@material-ui/core";
import { OptionalField } from "../../";

import useStyles from "../styles";

import { ChevronDown } from "../../../../../assets/icons";

function OptionalFieldAccordion({ optionalFields, onClickHandler }) {
  const styles = useStyles();
  const activeFields = Object.fromEntries(
    Object.entries(optionalFields).filter(([_, item]) => item.isActive)
  );
  const inActiveFields = Object.fromEntries(
    Object.entries(optionalFields).filter(([_, item]) => !item.isActive)
  );

  return (
    <Accordion className={styles.accordionWrapper}>
      <AccordionSummary className={styles.accordionSummary}>
        {Object.keys(activeFields).map((option) => (
          <OptionalField
            fieldData={optionalFields[option]}
            onClickHandler={onClickHandler}
            key={option}
          />
        ))}
        <Box display="flex" alignItems="center">
          <p className={styles.accordionSummaryText}>More rotation criteria</p>
          <ChevronDown width="20" height="20" fill={"#635235"} />
        </Box>
      </AccordionSummary>
      <AccordionDetails className={styles.accordionDetails}>
        {Object.keys(inActiveFields).map((option) => (
          <OptionalField
            fieldData={optionalFields[option]}
            onClickHandler={onClickHandler}
            key={option}
          />
        ))}
      </AccordionDetails>
    </Accordion>
  );
}

export default OptionalFieldAccordion;
